<template>
    <v-card>
      <v-data-iterator :items='perfResults' no-data-text='还没有考核成绩'>
        <template v-slot:header>
          <v-toolbar
            class="mb-2"
            flat
          >
            <v-toolbar-title>绩效成绩</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.name"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card :to="'/perfsumpage/'+item.year+'/'+item.month">
                <v-card-title class="subheading font-weight-bold">
                  {{ item.year }}年{{item.month}}月 {{item.users === item.done_users? '&check;':'&#9756;'}}
                </v-card-title>
                <v-card-text>共{{item.users}}人，已完成{{item.done_users}}人</v-card-text>
                <v-card-actions>
                  <v-row>
                    <v-col cols="4"></v-col>
                    <v-col cols="8">
                      <v-chip class="float-right" right color="primary">
                        查看打分
                        <v-icon right>mdi-chart-areaspline</v-icon>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-card>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    export default {
        name: 'PerfSum',

        data: () => ({
          perfResults:[],
          service:null
        }),
        created() {
          this.service = this.$store.getters.service('user-objective-rating')
          this.loadData()
        },
        computed: {
          ...mapState(['cur_user']), ...mapGetters(['myManageDepartments'])
        },
        methods: {
          async loadData() {

            const query = {
              customFind:{name:'getMonthlyScoreList'}
            }

            const response = await this.service.find({query})

            this.perfResults = response.data
          }
        }
    }
</script>